var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":!_vm.$store.getters.connection,"timeout":-1,"top":"","color":"error"}},[_c('v-icon',[_vm._v("mdi-alert")]),_vm._v(" "+_vm._s(_vm.$store.getters.sync_error)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }